export default __webpack_public_path__ + "static/media/close.9f1003c3.svg";